/* Container.tsx generated by @compiled/babel-plugin v0.6.0 */

import React from 'react';
import { ax, ix, CC, CS } from "@compiled/react/runtime";
import { borderRadius } from '@atlaskit/theme/constants';
var _15 = "._s7n41q9y{vertical-align:baseline}";
var _14 = "._1p1dangw{text-transform:uppercase}";
var _13 = "._19bvidpf{padding-left:0}";
var _12 = "._n3td1l7b{padding-bottom:3px}";
var _11 = "._u5f3idpf{padding-right:0}";
var _10 = "._ca0qyh40{padding-top:2px}";
var _9 = "._p12f1osq{max-width:100%}";
var _8 = "._vwz4kb7n{line-height:1}";
var _7 = "._k48p1fw0{font-weight:700}";
var _6 = "._1wyb1skh{font-size:11px}";
var _5 = "._1e0c1o8l{display:inline-block}";
var _4 = "._syaz1u00{color:var(--_srel9g)}";
var _3 = "._vchhusvi{box-sizing:border-box}";
var _2 = "._2rko1nwa{border-radius:var(--_fer9fa)}";
var _ = "._bfhkaxbu{background-color:var(--_1ly4823)}";
var BORDER_RADIUS = "".concat(borderRadius(), "px");
export default (function (_ref) {
  var backgroundColor = _ref.backgroundColor,
      textColor = _ref.textColor,
      children = _ref.children,
      testId = _ref.testId;
  return /*#__PURE__*/React.createElement(CC, null, /*#__PURE__*/React.createElement(CS, null, [_, _2, _3, _4, _5, _6, _7, _8, _9, _10, _11, _12, _13, _14, _15]), /*#__PURE__*/React.createElement("span", {
    "data-testid": testId,
    className: ax(["_bfhkaxbu _2rko1nwa _vchhusvi _syaz1u00 _1e0c1o8l _1wyb1skh _k48p1fw0 _vwz4kb7n _p12f1osq _ca0qyh40 _u5f3idpf _n3td1l7b _19bvidpf _1p1dangw _s7n41q9y"]),
    style: {
      "--_1ly4823": ix(backgroundColor),
      "--_fer9fa": ix(BORDER_RADIUS),
      "--_srel9g": ix(textColor)
    }
  }, children));
});